// removed by extract-text-webpack-plugin
module.exports = {"root":"e8Y3F","flyingSaucer":"_20Lxi","heading":"JlgbC","subHeading":"Cxy4C"};